import { SvgIcons } from '@ngneat/svg-icon';
import { Observable } from 'rxjs';

export enum ToastMessageType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface ToastMessageViewModel {
  type: ToastMessageType;
  message$: Observable<string>;
  duration?: number;
  icon?: SvgIcons;
  closeable?: boolean;
}

export interface ToastMessageRef {
  vm: ToastMessageViewModel;
  close: () => void;
}
